import PropTypes from "prop-types";
import Tooltip from "@shared/v2/Tooltip";

const Percent = ({ className, size, tooltip, value }) => (
  <div
    className={`tw-flex-1 tw-my-[8px] tw-min-w-[40px] tw-flex tw-flex-col tw-justify-center tw-items-center tw-border-solid tw-border-x-0 tw-border-y-[1px] tw-border-gray-5 ${className}`}
  >
    <Tooltip
      trigger={
        <span className={`${size === "small" ? "tw-text-14d" : "tw-text-18d"} tw-text-gray-50 tw-font-bold`}>
          {value}
        </span>
      }
      content={`${value} ${tooltip}`}
    />
  </div>
);

Percent.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium"]),
  tooltip: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
};

Percent.defaultProps = {
  size: "medium",
  className: "",
};

export default Percent;
